interface QuizAnswerResultSplitProps {
  correct: number;
  incorrect: number;
  partially: number;
  unmarked: number;
  unanswered: number;
  questionCnt: number;
}

export default function QuizAnswerResultSplit(quizAnswerResultSplitProps: QuizAnswerResultSplitProps) {
  const { correct, incorrect, partially, unmarked, unanswered, questionCnt } = quizAnswerResultSplitProps;
  return (
    <div className="text-muted-foreground flex flex-col gap-0.5 text-sm">
      {!!correct && (
        <div className="inline-flex items-center gap-1">
          <div className="bg-success h-3 w-3 rounded-xs"></div>
          <p>
            Poprawnie <span className="text-accent-foreground">{correct}</span> • {Number((correct / questionCnt) * 100).toPrecision(3) + '%'}
          </p>
        </div>
      )}
      {!!partially && (
        <div className="inline-flex items-center gap-1">
          <div className="bg-warning h-3 w-3 rounded-xs"></div>
          <p>
            Częściowo <span className="text-accent-foreground">{partially}</span> • {Number((partially / questionCnt) * 100).toPrecision(3) + '%'}
          </p>
        </div>
      )}
      {!!incorrect && (
        <div className="inline-flex items-center gap-1">
          <div className="bg-destructive h-3 w-3 rounded-xs"></div>
          <p>
            Niepoprawne <span className="text-accent-foreground">{incorrect}</span> • {Number((incorrect / questionCnt) * 100).toPrecision(3) + '%'}
          </p>
        </div>
      )}
      {!!unmarked && (
        <div className="inline-flex items-center gap-1">
          <div className="bg-gray h-3 w-3 rounded-xs"></div>
          <p>
            Czeka na ocene <span className="text-accent-foreground">{unmarked}</span> • {Number((unmarked / questionCnt) * 100).toPrecision(3) + '%'}
          </p>
        </div>
      )}
      {!!unanswered && (
        <div className="inline-flex items-center gap-1">
          <div className="bg-muted h-3 w-3 rounded-xs"></div>
          <p>
            Brak odpowiedzi <span className="text-accent-foreground">{unanswered}</span> • {Number((unanswered / questionCnt) * 100).toPrecision(3) + '%'}
          </p>
        </div>
      )}
    </div>
  );
}
